let LightHandler = function (___settings, ___handlers) {
  const THREE = require('../../../../../externals/three'),
        LightHandlerInterface = require('../../../../interfaces/handlers/LightHandlerInterface'),
        ExpoTHREE = ___settings.externalLibraries.ExpoTHREE,
        _handlers = ___handlers;

  let that,
      _lights,
      _sceneBS = new THREE.Sphere(),
      _ambientLight, 
      _directionalLight, _directionalLightTarget,
      _directionalLight2, _directionalLightTarget2,
      _active = true;

  class LightHandler extends LightHandlerInterface {

    constructor() {
      super();
      that = this;
      _lights = new THREE.Object3D();
      _handlers.threeDManager.helpers.addViewportObject(_lights);

      _ambientLight = new THREE.AmbientLight(0x404040);
      _lights.add(_ambientLight);

      _directionalLight = new THREE.DirectionalLight(0xffffff, 1);
      _lights.add(_directionalLight);
      _directionalLight.direction = { x: .5774, y: -.5774, z: .5774 };
      _directionalLight.castShadow = true;
      //_directionalLight.shadow.camera.up.set(0,0,1);
      _directionalLight.shadow.mapSize.width = 1024;  // default
      _directionalLight.shadow.mapSize.height = 1024; // default
      _directionalLight.shadow.camera.near = 0.1;
      _directionalLight.shadow.camera.far = 8 * _sceneBS.radius;
      _directionalLight.shadow.camera.right = 1.5 * _sceneBS.radius;
      _directionalLight.shadow.camera.left = -1.5 * _sceneBS.radius;
      _directionalLight.shadow.camera.top = 1.5 * _sceneBS.radius;
      _directionalLight.shadow.camera.bottom = -1.5 * _sceneBS.radius;
      _directionalLight.shadow.radius = 2;
      _directionalLight.shadow.bias = -0.000175;
      _directionalLight.shadow.camera.updateProjectionMatrix();

      _directionalLightTarget = new THREE.Object3D();
      _lights.add(_directionalLightTarget);
      _directionalLight.target = _directionalLightTarget;

      _directionalLight.position.set(_sceneBS.center.x + _sceneBS.radius * 2.35 * _directionalLight.direction.x, _sceneBS.center.y + _sceneBS.radius * 2.35 * _directionalLight.direction.y, _sceneBS.center.z + _sceneBS.radius * 2.35 * _directionalLight.direction.z);
      _directionalLight.target.position.set(_sceneBS.center.x, _sceneBS.center.y, _sceneBS.center.x);

      _directionalLight2 = new THREE.DirectionalLight(0xffffff, 1);
      _lights.add(_directionalLight2);
      _directionalLight2.direction = { x: .5774, y: .5774, z: .5774 };

      _directionalLightTarget2 = new THREE.Object3D();
      _lights.add(_directionalLightTarget2);
      _directionalLight2.target = _directionalLightTarget2;

      _directionalLight2.position.set(_sceneBS.center.x + _sceneBS.radius * 2.35 * _directionalLight2.direction.x, _sceneBS.center.y + _sceneBS.radius * 2.35 * _directionalLight2.direction.y, _sceneBS.center.z + _sceneBS.radius * 2.35 * _directionalLight2.direction.z);
      _directionalLight2.target.position.set(_sceneBS.center.x, _sceneBS.center.y, _sceneBS.center.x);
    }

    ////////////
    ////////////
    //
    // LightHandler API
    //
    ////////////
    ////////////
    
    /** @inheritdoc */
    pause() {
      _active = false;
    }

    /** @inheritdoc */
    resume() {
      _active = true;
    }

    /** @inheritdoc */
    destroy() {
      // destroy the light handler
    }




    /** @inheritdoc */
    adjustToBoundingSphere(bs) {
      _sceneBS = bs.clone();
      if(!_lights) return;
      _directionalLight.position.set(_sceneBS.center.x + _sceneBS.radius * 2.35 * _directionalLight.direction.x, _sceneBS.center.y + _sceneBS.radius * 2.35 * _directionalLight.direction.y, _sceneBS.center.z + _sceneBS.radius * 2.35 * _directionalLight.direction.z);
      _directionalLight.target.position.set(_sceneBS.center.x, _sceneBS.center.y, _sceneBS.center.x);
      _directionalLight.shadow.camera.far = 8 * bs.radius;
      _directionalLight.shadow.camera.right = 1.5 * bs.radius;
      _directionalLight.shadow.camera.left = -1.5 * bs.radius;
      _directionalLight.shadow.camera.top = 1.5 * bs.radius;
      _directionalLight.shadow.camera.bottom = -1.5 * bs.radius;
      _directionalLight.shadow.camera.updateProjectionMatrix();

      _directionalLight2.position.set(_sceneBS.center.x + _sceneBS.radius * 2.35 * _directionalLight2.direction.x, _sceneBS.center.y + _sceneBS.radius * 2.35 * _directionalLight2.direction.y, _sceneBS.center.z + _sceneBS.radius * 2.35 * _directionalLight2.direction.z);
      _directionalLight2.target.position.set(_sceneBS.center.x, _sceneBS.center.y, _sceneBS.center.x);
    }

    /** @inheritdoc */
    setToggleLightShadows(toggle) {
      _directionalLight.castShadow = toggle;
    }

    /** @inheritdoc */
    toggleLights(toggle) {
      _directionalLight.visible = toggle;
      _directionalLight2.visible = toggle;
    }
  }

  return new LightHandler();
};

module.exports = LightHandler;